import { useFormContext } from 'react-hook-form';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { Toggle } from 'features/common/components/Toggle';
import { InputToggleProps } from 'features/common/components/Form/types';
import { StyledLabel } from './InputToggle.styles';

export const InputToggle = ({
	name,
	label,
	htmlFor,
	isPunchup = false,
	...rest
}: InputToggleProps & { isPunchup?: boolean }) => {
	const { watch, setValue } = useFormContext();
	const toggleValue = watch(name);

	return (
		<FlexContainer justifyContent="space-between" alignItems="center" margin="8px 0" width="100%">
			<StyledLabel htmlFor={htmlFor} isPunchup={isPunchup} {...rest}>
				{label}
			</StyledLabel>
			<Toggle
				isChecked={toggleValue}
				handleClick={() => setValue(name, !toggleValue)}
				name={name}
				isPunchup={isPunchup}
			/>
		</FlexContainer>
	);
};
